import { FC } from 'react';
// Models
import IQuestion from 'models/Question';
// Types
import QuestionTypes from 'types/QuestionTypes';
import QuestionFormats from 'types/QuestionFormats';
// Components
import QuestionMultiAnswer from './MultiAnswer';
import QuestionTextAnswer from './TextAnswer';
import QuestionAnswer from './Answer';
import QuestionGameScoreAnswer from './GameScoreAnswer';
import Accordion from 'components/Accordion';

type Props = {
  question: IQuestion;
  index: number;
}

const Question:FC<Props> = ({ question, index }) => {
  return (
    <div react-scroll={`correct-answer-${index}`}>
      <Accordion label={`${index + 1}. ${question.title}`} icon="help">
        <div className="w-full">
          <div className="w-full px-6 pb-3">
            {question.type === QuestionTypes.SingleChoice && (
              <QuestionAnswer questionIndex={index} />
            )}
            {question.type === QuestionTypes.MultiChoice && (
              question.answers.map((answer, i) => (
                <QuestionMultiAnswer
                  key={answer.ref}
                  answer={answer}
                  index={i}
                  questionIndex={index}
                />
              ))
            )}
            {question.type === QuestionTypes.ShortText && (
              question.format === QuestionFormats.Score
                ? <QuestionGameScoreAnswer questionIndex={index} />
                : <QuestionTextAnswer questionIndex={index} />
            )}
          </div>
        </div>
      </Accordion>
    </div>
  )
}

export default Question;
